import { LitElement, css, html } from 'lit';
import { customElement, state } from 'lit/decorators';
import { getQueryStringParameters, parseCategoryQueryString, redirectToLocation } from '../helpers/urls';

import { TopicCategory } from '../types';
import { getMainPage } from '../helpers/page-name';

@customElement('bulk-reg-page')
export class BulkRegPage extends LitElement {


    @state()
    templateName: String = '';

    @state()
    templateCategories: TopicCategory[] = [];

    async firstUpdated() {
        await this.startup();
    }

    private async startup() {
        const queryString = getQueryStringParameters();
        const default_title = queryString.get('default_title');
        const default_categories = queryString.get('default_categories');

        if (!default_title || !default_categories) {
            getMainPage().errorToastElement.showToast('Template parameters are missing.');
            redirectToLocation('/', 5000);
            return;
        }

        this.templateName = default_title;
        this.templateCategories = parseCategoryQueryString(default_categories);

        window.dispatchEvent(new CustomEvent('page-content-ready'));
    }

    render() {
        return html`
            <div id="container">
                <div id="header">
                    <div id="headerContent">
                        <a
                            id="logo"
                            href="https://proxi.co"
                            class="__web-inspector-hide-shortcut__"
                        >
                            <img src="/images/logo.png" style="max-height: 40px; max-width:100%" />
                        </a>
                    </div>
                </div>

                <div id="banner">
                    <span>THIS IS AN INTERNAL PAGE.</span>
                </div>

                <div id="main">
                    <bulk-reg-component
                        templateName="${this.templateName}"
                        .templateCategories="${this.templateCategories}"
                    >
                    </bulk-reg-component>
                </div>
                <error-toast id="errorToast"></error-toast>
            </div>
        `;
    }

    static get styles() {
        return css`
            #container {
                display: flex;
                flex-direction: column;
                height: 100%;
                width: 100%;
                position: absolute;
                top: 0px;
                left: 0px;
            }

            #header {
                width: 100%;
                height: 50px;
                background-color: var(--main-primary-color);
                margin: 0px;
            }

            #headerContent {
                display: flex;
                flex-direction: row;
                justify-content: right;
                height: 50px;
                padding: 5px 5px;
            }

            #logo {
                max-width: 40%;
                margin-top: auto;
                margin-bottom: auto;
                margin-right: 10px;
            }

            #banner {
                background-color: var(--main-primary-color);
                text-align: center;
                color: var(--theme-white-color);
            }

            #main {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: row;
                justify-content: center;
            }
        `;
    }
}
